import { render, staticRenderFns } from "./sync-mis-dialog.vue?vue&type=template&id=68af875b"
import script from "./sync-mis-dialog.vue?vue&type=script&lang=ts"
export * from "./sync-mis-dialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports